import { EdentulousOptions, PlanItem } from "../../plan.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { AbstractTreatment } from "../treatment";
import { TreatmentPriceConfiguration } from "../../../../price/price.model";

export class EdentulousRehab extends AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    const options: EdentulousOptions = <EdentulousOptions>item.options;

    // validate arch selected
    if (!options.arch) {
      return false;
    }

    // validate type
    if (!options.type) {
      return false;
    }

    // validate material
    if (!options.material) {
      return false;
    }

    // validate mode
    if (!options.mode) {
      return false;
    }

    // validate number of implants present
    if (options.type !== "complete_denture" && !options.implants) {
      return false;
    }
    // validate number
    if (options.mode === "all_on") {
      if (options.implants < 4 || options.implants > 6) {
        return false;
      }
    } else {
      if (options.implants < 2 || options.implants > 8) {
        return false;
      }
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    const options: EdentulousOptions = <EdentulousOptions>item.options;

    let archTooth;
    if (options.arch === "upper") {
      archTooth = [
        18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28,
      ];
    } else {
      archTooth = [
        48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38,
      ];
    }

    let option = `edentulous-rehab ${options.arch} ${options.type}`;

    if (options.type === "fixed_bridge") {
      option += ` ${options.mode}`;
    }

    if (options.type === "fixed_bridge" || options.type === "overdenture") {
      option += ` i${options.implants}`;
    }

    odontogram
      .filter((tooth) => archTooth.indexOf(tooth.number) > -1)
      .forEach((tooth) => {
        tooth.diagnosis = [];
        tooth.plan = [{ treatment: item.treatment, options: option }];
        tooth.missing = true;
        tooth.implant = true;
        tooth.gengiva_normal = false;
        tooth.bone_normal = false;
        tooth.bone_line_normal = true;
      });

    return odontogram;
  }

  static getPriceConfiguration(): TreatmentPriceConfiguration {
    return {
      type: "composite",
      single: true,
      identifier: this.getIdentifier(),
      variants: {
        identifier: "edentulous-rehab-type",
        type: "composite",
        options: [
          "ceramic2",
          "ceramic3",
          "ceramic4",
          "ceramic5",
          "ceramic6",
          "ceramic7",
          "ceramic8",
          "acrylic2",
          "acrylic3",
          "acrylic4",
          "acrylic5",
          "acrylic6",
          "acrylic7",
          "acrylic8",
        ],
      },
    };
  }

  static getNameIdentifier(item: PlanItem): string {
    const options: EdentulousOptions = <EdentulousOptions>item.options;

    let option;

    switch (options.type) {
      case "fixed_bridge":
        option = "F";
        break;
      case "overdenture":
        option = "O";
        break;
      case "complete_denture":
        option = "D";
        break;
    }

    switch (options.material) {
      case "ceramic":
        option = option + "C";
        break;
      case "acrylic":
        option = option + "A";
        break;
    }

    if (options.type === "fixed_bridge") {
      switch (options.mode) {
        case "vertical":
          option = option + "V";
          break;
        case "all_on":
          option = option + "A";
          break;
      }
    }

    return `edentulous-rehab_${option}`;
  }

  static getDescriptionIdentifiers(item: PlanItem): string[] {
    return [this.getNameIdentifier(item)];
  }

  static getIdentifier(): string {
    return "edentulous-rehab";
  }

  static supports(treatment: string): boolean {
    return treatment.startsWith(this.getIdentifier());
  }

  /*
    static getItemResume(item: PlanItem): any {
        return [
            {
                name: 'channels',
                value: item.options.channels ? ['plan.options.channels.' + item.options.channels] : []
            }
        ];
    }
    */

  static getTableData(item: PlanItem): any {
    return [
      item.options.implants
        ? ["plan.options.edentulous-rehab.implants." + item.options.implants]
        : [],
    ];
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/implants/edentulous-rehab.ts